import queryString from 'query-string'
import { configuration } from '../../api/api'
import { fetchEvents } from './fetchEvents'
import { setView, setCategory, setDate } from '../actions/setFilters'
import moment from 'moment'

export const FETCH_CONFIG_BEGIN = 'FETCH_CONFIG_BEGIN'
export const FETCH_CONFIG_SUCCESS = 'FETCH_CONFIG_SUCCESS'
export const FETCH_CONFIG_ERROR = 'FETCH_CONFIG_ERROR'

export const fetchConfiguration = () => async dispatch => {
  dispatch({ type: FETCH_CONFIG_BEGIN })
  const queryParams = queryString.parse(window.location.search)
  const { category, date, language, view } = queryParams

  let currentLanguage = 'en'

  if (language) {
    currentLanguage = queryParams.language
  }

  if (category) {
    dispatch(setCategory(category))
  }

  if (date) {
    dispatch(setDate(moment(date)))
  }

  if (view) {
    dispatch(setView(view))
  }

  return configuration(currentLanguage)
    .then(res => {
      if (
        res.data &&
        res.data['hydra:member']
      ) {
        const payload = res.data['hydra:member'].map(config => {
          const { id, options, labels } = config
          return {
            id,
            options,
            labels
          }
        })

        dispatch({
          type: FETCH_CONFIG_SUCCESS,
          payload
        })
        dispatch(fetchEvents())
      } else {
        dispatch({
          type: FETCH_CONFIG_ERROR,
          payload: 'There was an error retrieving configuration - please wait a moment, then try again.'
        })
      }
    })
    .catch(err => {
      dispatch({ type: FETCH_CONFIG_ERROR, payload: err })
    })
}
